module.exports = __webpack_public_path__ + "img/404.e9de795f.jpg";